// extracted by mini-css-extract-plugin
module.exports = {"emptyContainer":"speakers_emptyContainer__2gTAg","noRecord":"speakers_noRecord__2CmGx"};